import React from 'react';
import ReactDOM from 'react-dom';
import {
  Box,
  makeStyles,
  Dialog,
  DialogTitle,

} from '@material-ui/core';

const ModalPortal = (props) => {
  const {
    open,
    close,
    children,
    title,
    estilo,
    fullWidth,
    maxWidth
  } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: 'white',
      minHeight: '100%',
      paddingBottom: theme.spacing(0),
      paddingTop: theme.spacing(0),
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    modal: {
      ...estilo
    }
  }));
  const classes = useStyles();
  const conteudo = (
    <Dialog open={open} maxWidth={maxWidth} fullWidth={fullWidth} className={classes.modal} onClose={close}>
      <DialogTitle id="dialog">{title}</DialogTitle>
      <Box className={classes.root}>
        {children}
      </Box>
    </Dialog>
  );

  return ReactDOM.createPortal(conteudo, document.getElementById('modal-hook'));
};

export default ModalPortal;
